/* MXDVS cursor radar, 30.09.2026 (02.10: the search page filter chips and Results / Related tabs are left out;
   06.10: the product name on a product card gets its own blip, next to the one for the photo;
   06.10 (2): lighter on the CPU: cached target list, scans throttled, loop only runs while the cursor is on the page, rings animate with transform;
   06.10 (3): the name dot sits on the name text itself, and the rings stay hidden until their pulse starts;
   09.10: OFF when a page loads. Nothing is built until the HUD switches it on (snippets/site-hud.liquid))
   Moved out of layout/theme.liquid so the browser caches it.
   theme.liquid only loads this file where the radar is wanted
   (not on the cart page, not on the contact page, which is a radar itself). */
(function () {
  // Desktop only: needs a wide screen AND a real mouse.
  // On phones and tablets this exits immediately, so no radar markup,
  // no listeners and no animation loop are ever created.
  var desktopQuery = '(min-width: 990px) and (hover: hover) and (pointer: fine)';
  if (!window.matchMedia(desktopQuery).matches) return;
  if (window.__mxdvsRadar) return;
  window.__mxdvsRadar = true;

  function initRadar() {
    // Build the radar markup (previously hardcoded at the top of <body>)
    var radar = document.createElement('div');
    radar.id = 'radarCursor';
    radar.innerHTML =
      '<div class="radar-ring keep-empty"></div>' +
      '<div class="radar-ring keep-empty"></div>' +
      '<div class="radar-ring keep-empty"></div>' +
      '<div class="radar-sweep-glow keep-empty" id="radarSweepGlow"></div>' +
      '<div class="radar-sweep keep-empty" id="radarSweep"></div>' +
      '<div class="radar-center-dot keep-empty"></div>';
    document.body.insertBefore(radar, document.body.firstChild);

    var sweep = document.getElementById('radarSweep');
    var sweepGlow = document.getElementById('radarSweepGlow');

    var detectionRadius = 220;
    var radarRadius = 60;
    var sweepDurationMs = 4500;
    var flashWindowDeg = 6;
    var flashDecayMs = 900;
    var restingOpacity = 0.25;

    // Links inside these containers are never picked up.
    // .mxdvs-desktop-menu__panel = the links inside the desktop submenus,
    // so only the menu titles (like #HeaderDesktop-accessories) get a blip.
    // .ft-board__panel = the footer country selector list.
    // #CartDrawer = nothing inside the cart drawer gets a blip (the radar is hidden while it is open)
    // .mx-rail__sub = the sub menu links in the side rail (29.09.2026)
    // .mx-rail__slot = the system log and the country list in the side rail (29.09.2026)
    // [data-mxh-country], .mxh-cwin = the country button and the country window in the glass header (29.09.2026)
    // .mxh-drop = the sub menu links in the glass header's drop panel and MENU + overview (29.09.2026)
    // [data-mxc-chips] = the filter chips on the collection pages (in stock, limited, sale, type, size, price) (30.09.2026)
    // [data-mxs-filters], [data-mxs-tabs] = the filter chips, sort and Results / Related tabs on the search page (02.10.2026)
    // .wl-sizes = the size buttons on the wishlist page; the radar only picks up the pieces themselves (08.10.2026)
    var EXCLUDE = '.footer-accordion__list, .menu-drawer, .mxdvs-desktop-menu__panel, .ft-board__panel, #CartDrawer, .mx-rail__sub, .mx-rail__slot, [data-mxh-country], .mxh-cwin, .mxh-drop, [data-mxc-chips], [data-mxs-filters], [data-mxs-tabs], .wl-sizes';

    // Only links you can actually see get a blip: nothing hidden, faded out or not shown yet
    // (for example the original header kept hidden behind the glass header). (29.09.2026)
    function isShown(el) {
      if (typeof el.checkVisibility === 'function') {
        return el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
      }
      var cs = getComputedStyle(el);
      return cs.visibility !== 'hidden' && cs.display !== 'none';
    }

    // ---- Lighter on the CPU (06.10.2026) -------------------------------------------------
    // Values you can tune:
    var SCAN_MS = 50;          // the nearby links are re-checked at most every 50 ms (was: every frame)
    var FRAME_MS = 33;         // the sweep and blips are redrawn at about 30 frames per second (was: 60+)
    var MIN_MOVE_PX = 3;       // a mouse move smaller than this does not trigger a new scan
    var LIGHT_RINGS = true;    // the three pulsing rings animate with transform instead of width / height

    // The rings in assets/mxdvs-legacy.css animate width and height, which makes the browser
    // recalculate the layout on every frame. Same look, but with transform (runs on the graphics card).
    if (LIGHT_RINGS) {
      var ringStyle = document.createElement('style');
      ringStyle.textContent =
        // opacity 0 + scale(0) + fill-mode backwards: the 2nd and 3rd ring start 0.8s and 1.6s later;
        // without this they showed as a full 140px circle until their pulse began (06.10.2026)
        '.radar-ring{width:140px;height:140px;box-sizing:border-box;will-change:transform,opacity;' +
        'opacity:0;transform:translate(-50%,-50%) scale(0);' +
        'animation-name:mxRadarPingLight !important;animation-fill-mode:backwards !important;}' +
        '@keyframes mxRadarPingLight{' +
        '0%{transform:translate(-50%,-50%) scale(0);opacity:.4}' +
        '100%{transform:translate(-50%,-50%) scale(1);opacity:0}}' +
        '.radar-sweep,.radar-sweep-glow,.radar-blip{will-change:transform}';
      document.head.appendChild(ringStyle);
    }

    // While the cursor is over this element the radar switches to white
    var VIDEO_ZONE = '.header-wrapper';
    var ON_VIDEO_CLASS = 'radar--on-video';

    var cursorX = 0;
    var cursorY = 0;
    var lastScanX = -9999;
    var lastScanY = -9999;
    var cursorVisible = false;
    var onVideo = false;
    var active = {};
    var pool = [];
    var sweepStart = performance.now();
    var updatePending = false;
    var lastScan = 0;
    var lastFrame = 0;
    var looping = false;
    var scrolled = false;
    var zoneEl = null;

    // Besides links and buttons, the product name on a product card gets its own blip.
    // The whole card is one link, so before this only one blip showed, in the middle of the photo. (06.10.2026)
    // .mx-card__name-in is the name text itself, so the blip sits on the words, not in the middle
    // of the full-width name box. (06.10.2026)
    var TARGETS = 'a, button, .mx-card__name-in';

    // The list of possible targets is built once (and again when the page changes),
    // not on every mouse move. Excluded links are filtered out here, once.
    var targets = [];
    var ids = new WeakMap();
    var nextId = 0;

    function refreshTargets() {
      var all = document.querySelectorAll(TARGETS);
      var next = [];
      all.forEach(function (el) {
        if (el.closest(EXCLUDE)) return;
        if (!ids.has(el)) ids.set(el, nextId++);
        next.push(el);
      });
      targets = next;
      zoneEl = document.querySelector(VIDEO_ZONE);
    }

    var refreshTimer = null;
    function queueRefresh() {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        refreshTargets();
        if (cursorVisible) scheduleUpdate(true);
      }, 300);
    }

    refreshTargets();
    new MutationObserver(function (list) {
      // Changes inside the radar itself (new blips) do not matter
      for (var i = 0; i < list.length; i++) {
        if (!radar.contains(list[i].target)) { queueRefresh(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', queueRefresh);

    function getBlipEl() {
      var el = document.createElement('div');
      el.className = 'radar-blip keep-empty';
      radar.appendChild(el);
      return el;
    }

    function updateZone() {
      if (!zoneEl || !zoneEl.isConnected) zoneEl = document.querySelector(VIDEO_ZONE);
      var inside = false;

      if (zoneEl) {
        var r = zoneEl.getBoundingClientRect();
        inside = cursorX >= r.left && cursorX <= r.right && cursorY >= r.top && cursorY <= r.bottom;
      }

      if (inside !== onVideo) {
        onVideo = inside;
        radar.classList.toggle(ON_VIDEO_CLASS, inside);
      }
    }

    function updateTargets() {
      var stillActive = {};

      targets.forEach(function (el) {
        var rect = el.getBoundingClientRect();

        // Hidden elements report a 0 x 0 box at the top left corner of the screen.
        // Skipping them stops phantom blips near the desktop menu.
        if (rect.width === 0 && rect.height === 0) return;

        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        var dx = cx - cursorX;
        var dy = cy - cursorY;

        // Cheap check first (no square root), the visibility check only for nearby elements
        if (dx * dx + dy * dy > detectionRadius * detectionRadius) return;
        var distance = Math.sqrt(dx * dx + dy * dy);

        if (isShown(el)) {
          var key = 'link-' + ids.get(el);
          stillActive[key] = true;

          var angleDeg = Math.atan2(dy, dx) * (180 / Math.PI);
          var scaledDistance = (distance / detectionRadius) * radarRadius;

          if (!active[key]) {
            active[key] = {
              el: pool.pop() || getBlipEl(),
              angleDeg: angleDeg,
              scaledDistance: scaledDistance,
              flashStartTime: -Infinity,
              lastOpacity: '',
              lastTransform: ''
            };
          } else {
            active[key].angleDeg = angleDeg;
            active[key].scaledDistance = scaledDistance;
          }
        }
      });

      Object.keys(active).forEach(function (key) {
        if (!stillActive[key]) {
          pool.push(active[key].el);
          active[key].el.style.opacity = '0';
          delete active[key];
        }
      });
    }

    // Runs the zone check and link scan at most once every SCAN_MS (and only after real movement)
    function scheduleUpdate(force) {
      if (updatePending) return;
      var movedFar = Math.abs(cursorX - lastScanX) + Math.abs(cursorY - lastScanY) >= MIN_MOVE_PX;
      if (!force && !scrolled && !movedFar) return;
      updatePending = true;
      var wait = Math.max(0, SCAN_MS - (performance.now() - lastScan));
      setTimeout(function () {
        requestAnimationFrame(function () {
          updatePending = false;
          if (!cursorVisible) return;
          lastScan = performance.now();
          lastScanX = cursorX;
          lastScanY = cursorY;
          scrolled = false;
          updateZone();
          updateTargets();
        });
      }, wait);
    }

    function angularDiff(a, b) {
      var diff = Math.abs(a - b) % 360;
      return diff > 180 ? 360 - diff : diff;
    }

    function tick(now) {
      if (!looping) return;
      // The loop only runs while the cursor is on the page and the tab is visible
      if (!cursorVisible || document.hidden) { looping = false; return; }
      requestAnimationFrame(tick);
      if (now - lastFrame < FRAME_MS) return;
      lastFrame = now;

      var elapsed = (now - sweepStart) % sweepDurationMs;
      var sweepAngle = (elapsed / sweepDurationMs) * 360;
      sweep.style.transform = 'rotate(' + sweepAngle.toFixed(1) + 'deg)';
      if (sweepGlow) sweepGlow.style.transform = 'translate(-50%, -50%) rotate(' + sweepAngle.toFixed(1) + 'deg)';

      Object.keys(active).forEach(function (key) {
        var target = active[key];
        var diff = angularDiff(sweepAngle, ((target.angleDeg % 360) + 360) % 360);

        if (diff < flashWindowDeg && now - target.flashStartTime > flashDecayMs) {
          target.flashStartTime = now;
        }

        var t = Math.min(1, (now - target.flashStartTime) / flashDecayMs);
        var opacity = restingOpacity + (1 - restingOpacity) * (1 - t);
        var scale = 1 + 0.4 * (1 - t);

        var rad = target.angleDeg * (Math.PI / 180);
        var bx = Math.cos(rad) * target.scaledDistance;
        var by = Math.sin(rad) * target.scaledDistance;

        // Only touch the page when the value really changed
        var op = opacity.toFixed(2);
        var tf = 'translate(' + bx.toFixed(1) + 'px, ' + by.toFixed(1) + 'px) translate(-50%, -50%) scale(' + scale.toFixed(2) + ')';
        if (op !== target.lastOpacity) { target.el.style.opacity = op; target.lastOpacity = op; }
        if (tf !== target.lastTransform) { target.el.style.transform = tf; target.lastTransform = tf; }
      });
    }

    function startLoop() {
      if (looping || document.hidden) return;
      looping = true;
      requestAnimationFrame(tick);
    }

    // Switched off again in the HUD (html.radar-off): hide the radar and let the loop stop (09.10.2026)
    function radarIsOn() {
      return !document.documentElement.classList.contains('radar-off');
    }

    document.addEventListener('mousemove', function (event) {
      cursorX = event.clientX;
      cursorY = event.clientY;
      if (!radarIsOn()) {
        if (cursorVisible) { cursorVisible = false; radar.style.display = 'none'; }
        return;
      }
      cursorVisible = true;
      radar.style.display = 'block';
      radar.style.transform = 'translate(' + cursorX + 'px, ' + cursorY + 'px)';
      scheduleUpdate();
      startLoop();
    }, { passive: true });

    // Scrolling with a still mouse moves the header under the cursor,
    // so re-check the color zone and the nearby links on scroll too
    window.addEventListener('scroll', function () {
      if (!cursorVisible) return;
      scrolled = true;
      scheduleUpdate();
    }, { passive: true });

    document.addEventListener('mouseleave', function () {
      cursorVisible = false;
      radar.style.display = 'none';
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && cursorVisible) startLoop();
    });
  }

  // 09.10.2026: the radar is OFF when a page loads. Nothing is built and no loop runs until the HUD
  // switches it on (class html.radar-on + the "mxdvs:radar" event), so visitors who never use it pay nothing.
  var started = false;
  function boot() {
    if (started) return;
    if (!document.documentElement.classList.contains('radar-on')) return;
    started = true;
    initRadar();
  }
  function bootWhenReady() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  }
  window.addEventListener('mxdvs:radar', bootWhenReady);
  bootWhenReady();
})();